<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ date }}
        </p>
        <p>
            <b>{{ creditBureau.address_name }}</b>
            <br />
            <b>{{ address.street }}</b>
            <br />
            <b>{{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}</b>
        </p>
        <p>
            <b>SSN: {{ userStore.user.ssn }}</b>
        </p>
        <p class="letter-content">
            Re:	Dispute of completeness/accuracy of data contained in my consumer reports
        </p>
        <p>
            To {{ creditBureau.address_name }}:
        </p>
        <p class="letter-content">
            My name is {{ userStore.user.firstname }} {{ userStore.user.lastname }}. My date of birth is {{ userStore.user.dob }}. My social security number is {{ userStore.user.ssn }}. Enclosed please find a copy of my driver’s license as proof of my identity and mailing address. You have prepared inaccurate and incomplete consumer reports concerning me and published said reports to third parties in violation of the Fair Credit Reporting Act (“FCRA”). Unfortunately, your unlawful conduct has caused me a lot of stress and financial harm, including worry and other distress, out of pocket costs and expenses, and loss personal credit opportunities.
        </p>
        <p class="letter-content">
            The following tradeline that you prepared and published about me is inaccurate and incomplete:
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id, null, reportStore.getFilter())">
            <strong>
                {{ creditor.furnisher_name }} with account number
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
            </strong>
            <template v-if="creditor.reason">
                <br />
                {{ creditor.reason }}
            </template>
        </p>
        <p class="letter-content">
            I request that you <b>delete</b> the above-listed tradelines and provide me an updated copy of a consumer report prepared by you that you maintain and publish concerning me to third parties. Inform any and all persons that you published the disputed information to that it has been deleted. If you conclude that the tradeline item is verified, I request details of your method of verification. In addition, I request a description of the procedure used to determine the accuracy and completeness of the information of the above-listed disputed information that you included in a consumer report that you prepared and published concerning me, including, but not limited to, the business name and address of all furnishers of information contacted in connection with such information and the telephone number of such furnishers when you initially prepared the consumer report with the information, investigated the data, and reinvestigated it due to my current dispute.
        </p>
        <p class="letter-content">
            Unfortunately, it appears that you do not have reasonable procedures in place to assure maximum accuracy and completeness of the information that you include in your consumer reports that you prepare concerning me. Therefore, I request that any future inclusion of consumer information concerning me be sent to me first for my review before you prepare and publish any information in a consumer report about me so that I can confirm the accuracy and completeness of the same. Accordingly, I may be contacted at my address above for such verification or via email at {{ userStore.user.email }}.
        </p>
        <p class="letter-content">
            Your prompt attention to this matter is requested in compliance with federal and state laws.
        </p>
        <p>
            Regards,
        </p>
        <p class="letter-content">
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = lodash.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                address,
            };
        }
    };
</script>
